import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import { AttendenceAbsent, AttendenceBulk } from '../../services/LoginPageService';
import NotificationBar from '../notification/ServiceNotificationBar';

const BulkUpload = ({open,setOpen,setRefreshData}) => {
    const [fileUpload,setFileUpload]=useState('');
    const [openNotification, setNotification] = useState({
        status: false,
        type: 'error',
        message: '',
    });
    
    const onUpload=()=>{
        AttendenceBulk({
            file:fileUpload
        },handleAttendenceBulk,handleAttendenceBulkException);
    }
    const onCancel=()=>{
        setOpen(false);
    }
    
    const handleAttendenceBulk=(dataObject)=>{
        console.log(dataObject);
        setNotification({
            status: true,
            type: 'success',
            message: dataObject.message,
        });
        setTimeout(()=>{
            setOpen(false);
        }, 2000);

        AttendenceAbsent(handleAttendenceAbsent,handleAttendenceAbsentException);
        setRefreshData(oldValue => !oldValue);
        ClearData();
    }

    const handleAttendenceAbsent=(dataObject)=>{
        console.log(dataObject.data);
    }

    const handleAttendenceAbsentException=(errorObject,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleAttendenceBulkException=(errorObject,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleCloseNotify = () => {
        setNotification({
        status: false,
        type: '',
        message: '',
        });
    };
    
    return (
        <div>
            <Dialog sx={{ '& .MuiDialog-paper': { width: '32%', maxHeight: '100%' } }}
            maxWidth="lg"
            open={open}>
                <DialogTitle>
                    Bulk Uploads   
                </DialogTitle>
                <DialogContent>
                    <Grid>
                        <TextField 
                        fullWidth
                        onChange={(e) => {
                            if (e.target.files && e.target.files.length > 0) {
                                const reader = new FileReader();
                                reader.onload = () => {
                                    if (reader.readyState === 2) {
                                        setFileUpload(reader.result);
                                    
                                    }
                                };
                                reader.readAsDataURL(e.target.files[0]);
                            }
                        }}
                        InputLabelProps={{ shrink: true }}
                        type="file"/> 
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid>
                        <Button onClick={onCancel} style={{float:'right'}}>
                            Cancel
                        </Button>
                        <Button onClick={onUpload} style={{float:'right'}}>
                            Upload
                        </Button>
                    </Grid>
                </DialogActions>
                <NotificationBar
                handleClose={handleCloseNotify}
                notificationContent={openNotification.message}
                openNotification={openNotification.status}
                type={openNotification.type}/>
            </Dialog>
        </div>
    )
}

export default BulkUpload
